export default __webpack_public_path__ + "static/media/csc.b9e789ee.svg";